/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import querystring from 'querystring';

import { getApiEndpoint } from '../utils/getApiEndpoint';
import { jwtToken } from '../utils/storageHelpers';

export const buildThumbnailURL = (type: 'user' | 'organization' | 'project', seed: string, size = 24) =>
  `${getApiEndpoint()}/thumbnail/${type}?${querystring.encode({ seed, size })}`;

const blobToBase64 = (blob: Blob) =>
  new Promise<string | undefined>(resolve => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      resolve(reader.result?.toString());
    };
  });

export const fetchEntityAsBase64 = (src: string) =>
  new Promise<string | undefined>(resolve => {
    const headers = new Headers({ authorization: `Bearer ${jwtToken.get()}` });

    void window
      .fetch(src, { headers })
      .then(response => response.blob())
      .then(blob => blobToBase64(blob))
      .then(base64 => resolve(base64));
  });
